// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import PlayStoreWhiteBg from '../_raw/ui/icon_play_store_white_bg.svg';
import withIconProps from '../withIconProps';

export default withIconProps(PlayStoreWhiteBg, { shouldSetDefaultSize: false });
